"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.useInitializeContext = exports.useAccordionContext = exports.AccordionContext = void 0;
var react_1 = require("react");
var useControllableValue_1 = __importDefault(require("../../helpers/hook/useControllableValue"));
exports.AccordionContext = react_1.createContext(undefined);
var useAccordionContext = function () {
    var context = react_1.useContext(exports.AccordionContext);
    if (!context) {
        throw new Error('useAccordionContext must be inside an Accordion');
    }
    return context;
};
exports.useAccordionContext = useAccordionContext;
var useInitializeContext = function (_a) {
    var currentItem = _a.currentItem, onChanging = _a.onChanging, onChange = _a.onChange;
    var _b = useControllableValue_1["default"]({
        value: currentItem,
        onChanging: onChanging,
        onChange: onChange
    }), stateItem = _b[0], setStateItem = _b[1];
    var changeItem = react_1.useCallback(function (item) {
        setStateItem(item === stateItem ? null : item);
    }, [stateItem, setStateItem]);
    return {
        currentItem: stateItem,
        changeItem: changeItem
    };
};
exports.useInitializeContext = useInitializeContext;
//# sourceMappingURL=AccordionContext.js.map